
<!-- <mat-card class="example-container">

  <div class="container-fluid">
    <div class="row  feedback">
      <span>
        <h3>{{FeedbackType}}</h3>
      </span>
      <br>
    </div>
   
    <form [formGroup]=" feedBackFormGroup " (ngSubmit)="submitContactUsForm()">
    
      <div class="row ">
        <div class="col-md-12">
        
          <div class="col-md-3">
          </div>
         
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" required>
              <mat-error *ngIf="feedBackFormGroup.controls.name.invalid && (feedBackFormGroup.controls.name.dirty || feedBackFormGroup.controls.name.touched) || feedBackFormGroup.get('name').errors?.whitespace">
                {{getErrorMsgForAddFeedbackFormName()}}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>E-mail</mat-label>
              <input matInput formControlName="eMail" required>
              <mat-error *ngIf="feedBackFormGroup.controls.eMail.invalid && (feedBackFormGroup.controls.eMail.dirty || feedBackFormGroup.controls.eMail.touched) || feedBackFormGroup.get('eMail').errors?.whitespace">
                {{getErrorMsgForAddFeedbackFormEmail()}}
              </mat-error>

            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Mobile number</mat-label>
              <input matInput formControlName="mobileNo" minlength="10" maxlength="10" required>
              <mat-error *ngIf="feedBackFormGroup.controls.mobileNo.invalid && (feedBackFormGroup.controls.mobileNo.dirty || feedBackFormGroup.controls.mobileNo.touched) || feedBackFormGroup.get('mobileNo').errors?.whitespace">
                {{getErrorMsgForAddFeedbackMobileNumber()}}
              </mat-error>
            </mat-form-field>

          </div>
         
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Fax number</mat-label>
              <input matInput formControlName="fax" maxlength="15">
              <mat-error *ngIf="feedBackFormGroup.controls.fax.invalid &&(feedBackFormGroup.controls.fax.dirty || feedBackFormGroup.controls.fax.touched) ">
                {{getErrorMsgForAddFeedbackFaxNumber()}}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label> Address line1</mat-label>
              <input matInput formControlName="address1">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Address line2</mat-label>
              <input matInput formControlName="address2">
            </mat-form-field>


          </div>
         
          <div class="col-md-3">
          </div>
        </div>
      </div>
    
      <div class="row ">
        <div class="col-md-12">
        
          <div class="col-md-3">
          </div>
       
          <div class="col-md-6 col-sm-12 col-xs-12">
            <mat-form-field hintLabel="Max 500 characters" appearance="outline">
              <mat-label> Subject</mat-label>
              <textarea matInput #subject maxlength="500" formControlName="subject" mat-autosize required></textarea>
              <mat-hint align="end">{{subject.value?.length || 0}}/500</mat-hint>
              <mat-error *ngIf="feedBackFormGroup.controls.subject.invalid &&(feedBackFormGroup.controls.subject.dirty || feedBackFormGroup.controls.subject.touched) || feedBackFormGroup.get('subject').errors?.whitespace">
                {{getErrorMsgForAddFeedbackSubject()}}
              </mat-error>
            </mat-form-field>
            <mat-form-field hintLabel="Max 500 characters" appearance="outline">
              <mat-label> Message</mat-label>
              <textarea matInput #message maxlength="500" formControlName="message" mat-autosize required></textarea>

              <mat-hint align="end">{{message.value?.length || 0}}/500</mat-hint>
              <mat-error *ngIf="feedBackFormGroup.controls.message.invalid && (feedBackFormGroup.controls.message.dirty || feedBackFormGroup.controls.message.touched) || feedBackFormGroup.get('message').errors?.whitespace">
                {{getErrorMsgForAddFeedbackMessage()}}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Url</mat-label>
              <input matInput formControlName="url">
            </mat-form-field>
            </div>
            </div>
            </div>

            <div class="row">
              <div class="col-md-2"></div>
              <div class="col-md-4 clr">

                <button type="button" class ="attachment" mat-raised-button (click) ="attachment.click()"  >Attachments</button>
                <input class="file-upload" (change)="onFileChanged($event)" #attachment   type ="file" multiple>
                <div *ngFor="let images of imagesName"> {{images}} &nbsp;<i class="fas fa-times -4px" (click) ="onCancelAttachment(imagesName)" 
                  style ="cursor:pointer; color :#691883"></i></div>
            </div>
            </div>
            <div class ="row">
            <div class ="col-md-6"></div>
            <div class ="col-md-6">
            <button mat-raised-button color="primary" class="submit">Submit</button>&nbsp;
            <button mat-raised-button color="primary" (click)="reset()">Cancel</button>
            </div>
          </div>
          
        
    </form>
  </div>
</mat-card> -->

<section class="contact-us">
  <section class="main pb0 cmargin bg-grey">
    <div class="container">
        <div class="row">

            <div class="col-md-6 mb-sm-20 ">
                <!-- <h4 class="contact-title">
                    Our Contact Information
                </h4>
                <p class="mb-sm-20">We would like to hear comments and opinions about us. If you need further
                    assistance, please feel
                    free to contact us:</p> -->
                <div class="hv">
                    <h4 class="contact-title">
                        HEAD OFFICE - INDIA
                    </h4>
                    <ul class="contact-list list1">
                        <li><i class="fa fa-address-card"></i>&nbsp;<span> HOME FABRICS HASSAN
                                #1346D, 27th Cross, MCECHS Layout, <br> Dr Shivaramakaranth Nagar, Jakkur, Bangalore-560077,
                                INDIA
                            </span>
                        </li>
                        <li><i class="fa fa-mobile"></i>&nbsp;<span><strong>Phone:</strong>
                                <a href="tel:9620112612">+91 96201
                                    12612</a> /  <a href="tel:9620112616">+91 96201 12616</a>
                            </span>
                        </li>
                        <li><i class="fa fa-envelope-open"></i>&nbsp;<span><strong>E-mail:</strong>
                                <a href="mailto:po@homefabricsindia.com">po@homefabricsindia.com</a>
                            </span>
                        </li>
                        <li><i class="fa fa-user"></i>&nbsp;<span><strong>Contact Person:</strong>
                              Ram 
                            </span>
                        </li>
                    </ul>
                    <div class="map-link">
                        <a href="https://www.google.com/maps/place/Home+Fabrics+-+Head+Office+BANGALORE/@13.0742921,77.6170297,820m/data=!3m2!1e3!4b1!4m5!3m4!1s0x3bae19c58aaf12f9:0x308b3cfd0ac96d4!8m2!3d13.0742921!4d77.6192237"
                            target="_blank" rel="noopener noreferrer">View On Map</a>
                    </div>
                </div>

            </div>
            <div class="col-md-6 mb-sm-20">
              <div class="hv">
              <h4 class="contact-title">
                    HOME FABRICS - USA
                </h4>
                <ul class="contact-list list1 ">
                    <li><i class="fa fa-address-card"></i>&nbsp;<span>
                    #201 N.Brand Blvd, Suite 240, Glendale, CA-91203, USA
                        </span>
                    </li>
                    <li><i class="fa fa-mobile"></i><span>&nbsp;<strong>Phone:</strong>
                            <a href="tel: +12138408874"> +1 213 8408874</a>
                        </span>
                    </li>
                    <li><i class="fa fa-envelope-open"></i>&nbsp;<span><strong>E-mail:</strong>
                            <a href="mailto:ravi@homefabricsindia.com">ravi@homefabricsindia.com</a>
                        </span>
                    </li>
                    <li><i class="fa fa-user"></i>&nbsp;<span><strong>Contact Person:</strong>
                              Ravi Kannepalli
                            </span>
                        </li>
                </ul>
                <div class="map-link">
                    <a href="https://www.google.com/maps/place/201+N+Brand+Blvd,+Glendale,+CA+91203,+USA/@34.1483306,-118.2555292,81m/data=!3m1!1e3!4m5!3m4!1s0x80c2c0550cdf9adb:0xdb56c6afa13d9ab4!8m2!3d34.148302!4d-118.2553817?hl=en-US"
                        target="_blank" rel="noopener noreferrer">View On Map</a>
                </div>
              </div>
            </div>
        </div>
    </div>
</section>
<section class="main xx bg-grey">
    <div class="container">
        <div class="row">
            <div class="col-md-6 mb-sm-20">
                <div class="hv">
                <h4 class="contact-title">
                    WAREHOUSE
                </h4>
                <ul class="contact-list list2">
                    <li><i class="fa fa-address-card"></i>&nbsp;<span>
                            #20th Cross, MCECHS Layout, 
                            Dr Shivaramakaranth Nagar, <br> Bangalore -560077, INDIA
                        </span>
                    </li>
                    <li><i class="fa fa-mobile"></i>&nbsp;<span><strong>Phone:</strong>
                            <a href="tel:08028444304">+91 80 2844 4304</a> / <a
                                href="tel:+919620112678">+91 96201 12678</a>
                        </span>
                    </li>
                    
                </ul>
                <div class="map-link">
                    <a href="https://www.google.com/maps/place/Home+Fabrics+Warehouse/@13.072437,77.6200512,820m/data=!3m2!1e3!4b1!4m5!3m4!1s0x3bae17da899fc7d9:0xc0bc6b1a2b0c7643!8m2!3d13.072437!4d77.6222452"
                        target="_blank" rel="noopener noreferrer">View On Map</a>
                </div>
                </div>
            </div>
            <div class="col-md-6 mb-sm-20">
              <div class="hv">
              <h4 class="contact-title">
                    MILLS : HOME FABRICS HASSAN
                </h4>
                <ul class="contact-list list2 ">
                    <li><i class="fa fa-address-card"></i>&nbsp;<span>
                            #40-B/A2, SEZ Textiles,
                            KIADB, H.N.Pura Road,
                            Hassan - 573201, INDIA

                        </span>
                    </li>
                    <li><i class="fa fa-mobile"></i>&nbsp;<span><strong>Phone:</strong>
                            <a href="tel:08172297024">+91 81 7229 7024</a> / <a
                                href="tel:+919343936607">+91 93439 36607</a>
                        </span>
                    </li>
                    
                </ul>
                <div class="map-link">
                    <a href="https://www.google.com/maps/place/Home+Fabrics+Hassan/@12.9558389,76.0993305,821m/data=!3m2!1e3!4b1!4m5!3m4!1s0x3ba5475cffaeaf65:0x749f06591d60a5cb!8m2!3d12.9558389!4d76.1015245"
                        target="_blank" rel="noopener noreferrer">View On Map</a>
                </div>
              </div>
            </div>

        </div>
    </div>
</section>

<section class="main bg-grey" style="padding-top: 20px;">
  <!-- <div class="container">

      <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
              <div class="contact">
                  <form method="post" action="home/contact" id="contactForm">
                    
                      <div class="row ">
                          <div class="col-sm-6">
                              <div class="form-group">

                                  <input name="name" type="text" class="form-control custom-control"
                                      placeholder="Your Name*" value="">
                                 
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <input name="phone" type="text" class="form-control custom-control"
                                      placeholder="Your Phone*" value="">
                                 
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <input name="email" type="text" class="form-control custom-control"
                                      placeholder="Your Email*" value="">
                                  
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <input name="subject" type="text" class="form-control custom-control"
                                      placeholder=" Subject*" value="">
                                  
                              </div>
                          </div>
                          <div class="col-sm-12">
                              <div class="form-group">
                                  <textarea name="message" type="text" class="form-control custom-control"
                                      placeholder="Your Message*"
                                      value=""></textarea>
                              </div>
                          </div>

                          <div class="col-sm-12">
                              <div class="form-group marcls">
                                  <div class="g-recaptcha"
                                      data-sitekey="6LfgeS8UAAAAAFzucpwQQef7KXcRi7Pzam5ZIqMX"></div>
                              </div>
                              <div class="error text-danger" style="margin-bottom:10px; margin-left:5px">
                              </div>
                          </div>
                          <div class="col-sm-12">

                              <div class="form-group ">
                                  <input type="submit" value="Send" class="btn btn-send">
                              </div>
                          </div>

                      </div>
                  </form>
              </div>
          </div>
          <div class="col-md-2"></div>
      </div>
  </div> -->

  <mat-card class="example-container">

    <div class="container ">
      <div class="row  feedback">
        <span>
          <h3>{{FeedbackType}}</h3>
        </span>
        <br>
      </div>
     
      <form [formGroup]=" feedBackFormGroup"  class="contactus-form">
      
        <div class="row ">
          <div class="col-md-12">
          
            <div class="col-md-3"></div>
           
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" required>
                <mat-error *ngIf="feedBackFormGroup.controls.name.invalid && (feedBackFormGroup.controls.name.dirty || feedBackFormGroup.controls.name.touched) || feedBackFormGroup.get('name').errors?.whitespace">
                  {{getErrorMsgForAddFeedbackFormName()}}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="eMail" required>
                <mat-error *ngIf="feedBackFormGroup.controls.eMail.invalid && (feedBackFormGroup.controls.eMail.dirty || feedBackFormGroup.controls.eMail.touched) || feedBackFormGroup.get('eMail').errors?.whitespace">
                  {{getErrorMsgForAddFeedbackFormEmail()}}
                </mat-error>
  
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Mobile number</mat-label>
                <input matInput formControlName="mobileNo" minlength="10" maxlength="10" required>
                <mat-error *ngIf="feedBackFormGroup.controls.mobileNo.invalid && (feedBackFormGroup.controls.mobileNo.dirty || feedBackFormGroup.controls.mobileNo.touched) || feedBackFormGroup.get('mobileNo').errors?.whitespace">
                  {{getErrorMsgForAddFeedbackMobileNumber()}}
                </mat-error>
              </mat-form-field>
  
            </div>
           
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Fax number</mat-label>
                <input matInput formControlName="fax" maxlength="15">
                <mat-error *ngIf="feedBackFormGroup.controls.fax.invalid &&(feedBackFormGroup.controls.fax.dirty || feedBackFormGroup.controls.fax.touched) ">
                  {{getErrorMsgForAddFeedbackFaxNumber()}}
                </mat-error>
              </mat-form-field>
  
              <mat-form-field appearance="outline">
                <mat-label> Address line1</mat-label>
                <input matInput formControlName="address1">
              </mat-form-field>
  
              <mat-form-field appearance="outline">
                <mat-label>Address line2</mat-label>
                <input matInput formControlName="address2">
              </mat-form-field>
  
  
            </div>
           
            <div class="col-md-3">
            </div>
          </div>
        </div>
      
        <div class="row ">
          <div class="col-md-12">
          
            <div class="col-md-3">
            </div>
         
            <div class="col-md-6 col-sm-12 col-xs-12">
              <mat-form-field hintLabel="Max 500 characters" appearance="outline">
                <mat-label> Subject</mat-label>
                <textarea matInput #subject maxlength="500" formControlName="subject" mat-autosize required></textarea>
                <mat-hint align="end">{{subject.value?.length || 0}}/500</mat-hint>
                <mat-error *ngIf="feedBackFormGroup.controls.subject.invalid &&(feedBackFormGroup.controls.subject.dirty || feedBackFormGroup.controls.subject.touched) || feedBackFormGroup.get('subject').errors?.whitespace">
                  {{getErrorMsgForAddFeedbackSubject()}}
                </mat-error>
              </mat-form-field>
              <mat-form-field hintLabel="Max 500 characters" appearance="outline">
                <mat-label> Message</mat-label>
                <textarea matInput #message maxlength="500" formControlName="message" mat-autosize required></textarea>
  
                <mat-hint align="end">{{message.value?.length || 0}}/500</mat-hint>
                <mat-error *ngIf="feedBackFormGroup.controls.message.invalid && (feedBackFormGroup.controls.message.dirty || feedBackFormGroup.controls.message.touched) || feedBackFormGroup.get('message').errors?.whitespace">
                  {{getErrorMsgForAddFeedbackMessage()}}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Url</mat-label>
                <input matInput formControlName="url">
              </mat-form-field>
              </div>
              </div>
              </div>
  
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4 clr">
  
                  <button type="button" class ="attachment" mat-raised-button (click) ="attachment.click()"  >Attachments</button>
                  <input class="file-upload" (change)="onFileChanged($event)" #attachment   type ="file" multiple>
                  <div *ngFor="let images of imagesName"> {{images}} &nbsp;<span class="close" (click) ="onCancelAttachment(imagesName)" 
                    style ="cursor:pointer; color: #696868">x</span></div>
              </div>
              </div>
              <div class ="row">
              <div class ="col-md-6"></div>
              <div class ="col-md-6">
              <button mat-raised-button color="primary" (click)="submitContactUsForm()">Submit</button>&nbsp;
              <button mat-raised-button color="primary" (click)="reset()">Cancel</button>
              </div>
            </div>
            
          
      </form>
    </div>
  </mat-card> 
</section>

</section>
